// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid-module_desk_2QxER","table":"Grid-module_table_37nSA","actions":"Grid-module_actions_1AGQU","dropdown":"Grid-module_dropdown_qLb8d","icon":"Grid-module_icon_1eW-_"};